<div class="adm-danger-zone">
  <div class="adm-danger-zone__copy">
    <p class="adm-danger-zone__title">{{ label() ?? 'Delete this record' }}</p>
    <p class="adm-danger-zone__desc">
      {{ description() ?? "Permanently removes this record. This can't be undone." }}
    </p>
  </div>
  <button type="button" class="btn btn-danger adm-danger-zone__action" (click)="onDeleteClick()" [disabled]="busy()">
    <i class="bx bx-trash" aria-hidden="true"></i>
    @if (busy()) {
      Deleting…
    } @else {
      {{ buttonText() ?? 'Delete' }}
    }
  </button>
</div>
